module.exports = __webpack_public_path__ + "static/media/female-developer.5d593e23.svg";